import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from "@azure/msal-browser";
import { MsalGuard, MsalRedirectComponent } from "@azure/msal-angular";

const routes: Routes = [
    {
        path: 'auth', component: MsalRedirectComponent,
        canActivate: [MsalGuard]
    },
    {
        path: '',
        loadChildren: () => import('./components/product/product.module').then(m => m.ProductModule),
    },
    {
        path: 'settings',
        loadChildren: () => import('./components/settings/settings.module').then(m => m.SettingsModule),
    },
];

@NgModule({
    // TODO: Note: scroll options DONT work.
    imports: [RouterModule.forRoot(routes, {
        initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled', // Set to enabledBlocking to use Angular Universal
        scrollPositionRestoration: 'enabled',
        // anchorScrolling: 'enabled'
    })],
    exports: [RouterModule],
})
export class AppRoutingModule
{
}
